import React, { useEffect } from 'react'
import { View } from 'react-native'
import Animated, { Easing, useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated'

import { useBreakpoints } from '@pff-consumer/tweed-ui/styles/use-dimensions'
import { Icon } from '@pff-consumer/tweed-ui/atoms/icon/icon'
import { Text, TextDescriptionVariant } from '@pff-consumer/tweed-ui/atoms/browser-text'
import { useTheme } from '@pff-consumer/tweed-ui/styles/theme'
import { CurrentProgressState } from '@pff-consumer/schema'
import { SVGGroup } from '@pff-consumer/utils/lib/svg/svg-group'
import { useStyles } from './progress-pane.styles'
import type { ProgressPaneProps } from './progress-pane.props'

export const ProgressPane = (props: ProgressPaneProps) => {
  const { children, header, message, state } = props
  const theme = useTheme()
  const { isDesktop } = useBreakpoints()
  const styles = useStyles({ isDesktop })

  const spinValue = useSharedValue(0)

  const spinStyle = useAnimatedStyle(() => {
    return {
      transform: [{ rotate: `${spinValue.value}deg` }],
    }
  })

  useEffect(() => {
    spinValue.value = withRepeat(
      withTiming(360, {
        duration: 800,
        easing: Easing.linear,
      }),
      -1, // -1 means repeat indefinitely
      false
    )
  }, [])

  return (
    <View
      style={styles.container}
      key={state}
    >
      <Animated.View style={[styles.iconContainer, state === CurrentProgressState.IN_PROGRESS ? spinStyle : {}]}>
        <Icon
          group={SVGGroup.Icons}
          testID='fantasySync.progressState.icon'
          name={state}
          width='92'
          height='92'
        />
      </Animated.View>
      <View style={styles.header}>
        <Text
          variant={TextDescriptionVariant.MODAL_HEADER}
          colorOverride={theme.colors.webModalHeaderColor}
        >
          {header}
        </Text>
      </View>
      <View style={styles.message}>
        <Text
          variant={TextDescriptionVariant.MODAL_DESCRIPTION}
          colorOverride={theme.colors.webModalDescriptionColor}
        >
          {message}
        </Text>
      </View>
      {children}
    </View>
  )
}
